export default "__VITE_ASSET__Cdg5l7Ia__"